module.exports = new __parcel__URL__("news07.ece1af85.jpg").toString();